// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as PerspectivesRouteImport } from './routes/perspectives'
import { Route as ManifestoRouteImport } from './routes/manifesto'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as CanvasRouteImport } from './routes/canvas'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CareersIndexRouteImport } from './routes/careers.index'
import { Route as CareersSlugRouteImport } from './routes/careers.$slug'
import { Route as PerspectivesIndexRouteImport } from './routes/perspectives.index'
import { Route as PerspectivesSlugRouteImport } from './routes/perspectives.$slug'
import { Route as LegalIndexRouteImport } from './routes/legal.index'
import { Route as LegalPrivacyPolicyRouteImport } from './routes/legal.privacy-policy'
import { Route as CanvasIndexRouteImport } from './routes/canvas.index'
import { Route as CanvasCustomRouteImport } from './routes/canvas.custom'

const PlatformRoute = PlatformRouteImport.update({
            id: '/platform',path: '/platform',getParentRoute: () => rootRouteImport
          })
const PerspectivesRoute = PerspectivesRouteImport.update({
            id: '/perspectives',path: '/perspectives',getParentRoute: () => rootRouteImport
          })
const ManifestoRoute = ManifestoRouteImport.update({
            id: '/manifesto',path: '/manifesto',getParentRoute: () => rootRouteImport
          })
const LegalRoute = LegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => rootRouteImport
          })
const CanvasRoute = CanvasRouteImport.update({
            id: '/canvas',path: '/canvas',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CareersIndexRoute = CareersIndexRouteImport.update({
            id: '/careers/',path: '/careers/',getParentRoute: () => rootRouteImport
          })
const CareersSlugRoute = CareersSlugRouteImport.update({
            id: '/careers/$slug',path: '/careers/$slug',getParentRoute: () => rootRouteImport
          })
const PerspectivesIndexRoute = PerspectivesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PerspectivesRoute
          })
const PerspectivesSlugRoute = PerspectivesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => PerspectivesRoute
          })
const LegalIndexRoute = LegalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LegalRoute
          })
const LegalPrivacyPolicyRoute = LegalPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => LegalRoute
          })
const CanvasIndexRoute = CanvasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CanvasRoute
          })
const CanvasCustomRoute = CanvasCustomRouteImport.update({
            id: '/custom',path: '/custom',getParentRoute: () => CanvasRoute
          })





const CanvasRouteChildren = {
  CanvasCustomRoute: CanvasCustomRoute,CanvasIndexRoute: CanvasIndexRoute
}

const CanvasRouteWithChildren = CanvasRoute._addFileChildren(CanvasRouteChildren)




const LegalRouteChildren = {
  LegalPrivacyPolicyRoute: LegalPrivacyPolicyRoute,LegalIndexRoute: LegalIndexRoute
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)




const PerspectivesRouteChildren = {
  PerspectivesSlugRoute: PerspectivesSlugRoute,PerspectivesIndexRoute: PerspectivesIndexRoute
}

const PerspectivesRouteWithChildren = PerspectivesRoute._addFileChildren(PerspectivesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,CanvasRoute: CanvasRouteWithChildren,LegalRoute: LegalRouteWithChildren,ManifestoRoute: ManifestoRoute,PerspectivesRoute: PerspectivesRouteWithChildren,PlatformRoute: PlatformRoute,CareersSlugRoute: CareersSlugRoute,CareersIndexRoute: CareersIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)